import React from 'react';
import { Flex, Image } from '@skin-seoul/design-system';
import { useProductCard } from '../ProductCardContext';
const ProductImage = () => {
  const {
    productImage,
    name
  } = useProductCard();
  return <Flex align="center" height="100%" justify="center" width="100%" minWidth="0" overflow="hidden" data-sentry-element="Flex" data-sentry-component="ProductImage" data-sentry-source-file="ProductImage.tsx">
      <Image alt={name} width="100%" height="100%" objectFit="contain" src={productImage} style={{
      mixBlendMode: 'darken'
    }} maxWidth="100%" loading="lazy" maxHeight="100%" data-sentry-element="Image" data-sentry-source-file="ProductImage.tsx" />
    </Flex>;
};
export default ProductImage;